import TeamHomeAwayImage from './TeamHomeAwayImage';
import { TeamHomeAwayImageProps, TeamHomeAwayImageValueProps } from './types';

export type { TeamHomeAwayImageProps, TeamHomeAwayImageValueProps };
export default TeamHomeAwayImage;
